import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { Search } from './pages/search/search';
import { PrivacyPolicy } from './pages/privacy-policy/privacy-policy';
import { Bar } from './pages/bar/bar';
import { ListDetail } from './pages/list/list';
import { Statistics } from './pages/statistics/statistics';
import { NotificationsAdmin } from './pages/notifications-admin/notifications-admin';
import { Login } from './pages/login/login';
import { DeleteAccount } from './pages/delete-account/delete-account';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
        path: 'login',
        component: Login
    },
    {
        path: 'home',
        component: Home
    },
    {
        path: 'search',
        component: Search
    },
    {
        path: 'bar/:id',
        component: Bar
    },
    {
        path: 'lists/:id',
        component: ListDetail
    },
    {
        path: 'privacy-policy',
        component: PrivacyPolicy
    },
    {
        path: 'delete-account',
        component: DeleteAccount
    },
    {
        path: 'statistics',
        component: Statistics,
        canActivate: [adminGuard]
    },
    {
        path: 'notifications-admin',
        component: NotificationsAdmin,
        canActivate: [adminGuard]
    },
    {
        path: '**',
        redirectTo: 'home'
    }

];
